import { render, staticRenderFns } from "./SituacionLaboralForm.vue?vue&type=template&id=386d2aa1&scoped=true"
import script from "./SituacionLaboralForm.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d2aa1",
  null
  
)

export default component.exports